var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import React from 'react';
import { space } from 'styled-system';
import { styled } from "../../utils";
import Button from './Button';
var StyledButton = styled(Button)(function (_a) {
    var fontWeights = _a.theme.fontWeights;
    return "\n    && {\n      display: flex;\n      font-weight: ".concat(fontWeights.bold, ";\n      align-items: center;\n    }\n  ");
}, space);
var EditButton = function (_a) {
    var children = _a.children, variant = _a.variant, icon = _a.icon, props = __rest(_a, ["children", "variant", "icon"]);
    return (React.createElement(StyledButton, __assign({ ghost: true, paddingX: variant === 'block' ? 4 : 0, paddingY: variant === 'block' ? 3 : 0, shadow: variant === 'block' }, props),
        icon && icon,
        children));
};
EditButton.defaultProps = {
    children: 'Ändern',
    variant: 'block',
    icon: React.createElement(Icon.Pencil, null),
};
export default EditButton;
//# sourceMappingURL=EditButton.js.map